import { Component, Input, OnDestroy, OnInit, Output, EventEmitter } from '@angular/core';
import { NotificationModel } from '../../shared/models/notification.model';
import moment from 'moment';
import { Subscription } from 'rxjs';
import { UserService } from '../../shared/services/user.service';
import { Router } from '@angular/router';
import { HelpService } from '../../shared/services/help.service';
import { MaterialModule } from '../../shared/material.module';
import { NgClass, NgForOf, NgIf } from '@angular/common';

@Component({
  selector: 'app-notifications',
  standalone: true,
  imports: [
    MaterialModule,
    NgForOf,
    NgClass,
    NgIf
  ],
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit, OnDestroy {

  @Input() notifications: NotificationModel[];
  @Output() reloadNotifications = new EventEmitter<boolean>();
  loading = false;

  private dismiss: Subscription;
  constructor(private userService: UserService, private router: Router, private helpService: HelpService) { }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    if (this.dismiss) { this.dismiss.unsubscribe(); }
  }

  parseDateFormat(date: string): string {
    return moment(date).fromNow();
  }

  dismissNotification(notification: NotificationModel): void {
    notification.IsDismissed = true;
    this.loading = true;
    this.dismiss = this.userService.dismissNotification(notification).subscribe(() => {
      this.loading = false;
      this.reloadNotifications.emit(true);
      this.helpService.openSnackbar('Notification Dismissed.', 'success', 1000);
    }, () => {
      this.loading = false;
      this.helpService.openSnackbar('Notification ERROR: Please try again!', 'error', 1000);
    });
  }

  redirectNotification(notification: NotificationModel): void {
    if (notification.NotificationLink && notification.NotificationLinkType === 'External') {
      window.open(notification?.NotificationLink, '_blank')?.focus();
    } else if (notification.NotificationLink && notification.NotificationLinkType === 'Internal') {
      this.router.navigate([notification.NotificationLink]);
    }

    this.dismissNotification(notification);
  }

}
